import s from './Line.module.scss';

type TLineProps = {
    className?: string;
};

export const Line = ({ className }: TLineProps) => {
    return (
        <div className={`${s.line} ${className}`}></div>
    );
};